import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '@launchmetrics/lm-ui';
import React from 'react';

function createSvgIcon(path, displayName, additionalProps) {
    function Component(props, ref) {
        return (jsx(SvgIcon, __assign({ "data-testid": "".concat(displayName, "Icon"), ref: ref }, additionalProps, props, { children: path })));
    }
    Component.displayName = "".concat(displayName, "Icon");
    return React.memo(React.forwardRef(Component));
}

export { createSvgIcon as default };
